import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../contexts/AuthContext";
import { toast } from "react-toastify";
import EditStageModal from "./EditStageModal";
import DeleteConfirmModal from "./DeleteConfirmModal";
import CreateChallengeForm from "./CreateChallengeForm";
import EditChallengeModal from "./EditChallengeModal";
import DeleteChallengeModal from "./DeleteChallengeModal";

const StagesList = ({ stages, loading, onRefresh }) => {
  const [expandedStages, setExpandedStages] = useState({});
  const [editingStage, setEditingStage] = useState(null);
  const [deletingStage, setDeletingStage] = useState(null);
  const [addingChallengeToStage, setAddingChallengeToStage] = useState(null);
  const [editingChallenge, setEditingChallenge] = useState(null);
  const [deletingChallenge, setDeletingChallenge] = useState(null);
  const [activatingChallenge, setActivatingChallenge] = useState(null); // 👈 جدید
  const { apiBaseUrl } = useAuth();

  const toggleStageExpand = (stageId) => {
    setExpandedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "in_progress":
        return "text-green-400";
      case "done":
        return "text-blue-400";
      default:
        return "text-gray-400";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "in_progress":
        return "در حال انجام";
      case "done":
        return "انجام شده";
      default:
        return status;
    }
  };

  const handleEditClick = (stage) => {
    setEditingStage(stage);
  };

  const handleCloseModal = () => {
    setEditingStage(null);
  };

  const handleUpdateSuccess = () => {
    setEditingStage(null);
    onRefresh();
  };

  const handleDeleteClick = (stage) => {
    setDeletingStage(stage);
  };

  const handleCloseDeleteModal = () => {
    setDeletingStage(null);
  };

  const handleDeleteSuccess = () => {
    setDeletingStage(null);
    onRefresh();
  };

  const handleAddChallengeClick = (stage) => {
    setAddingChallengeToStage(stage);
  };

  const handleCancelAddChallenge = () => {
    setAddingChallengeToStage(null);
  };

  const handleChallengeCreated = () => {
    setAddingChallengeToStage(null);
    onRefresh();
  };

  // 👇 تابع جدید برای فعال‌سازی چلنج
  const handleActivateChallenge = async (challenge) => {
    if (
      !window.confirm(`آیا از فعال‌سازی چلنج "${challenge.name}" مطمئن هستید؟`)
    ) {
      return;
    }

    try {
      setActivatingChallenge(challenge.id);

      const response = await axios.put(
        `${apiBaseUrl}/api/tournament/admin/initiate/${challenge.id}`
      );

      toast.success(`چلنج "${challenge.name}" با موفقیت فعال شد!`);

      // رفرش کردن لیست
      onRefresh();
    } catch (error) {
      console.error("❌ خطا در فعال‌سازی چلنج:", error);
      toast.error(error.response?.data?.message || "خطا در فعال‌سازی چلنج");
    } finally {
      setActivatingChallenge(null);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
        <button
          onClick={onRefresh}
          disabled={loading}
          className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
              در حال دریافت...
            </>
          ) : (
            "بارگذاری مجدد"
          )}
        </button>
      </div>

      {stages.length > 0 ? (
        <div className="bg-gray-800 border border-gray-600 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-700">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                    #
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                    نام استیج
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                    تعداد چلنج‌ها
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {stages.map((stage) => (
                  <React.Fragment key={stage.id}>
                    {/* ردیف استیج */}
                    <tr className="hover:bg-gray-750 transition">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                        {stage.id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">
                        {stage.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">
                        <span className="px-3 py-1 bg-blue-900/50 text-blue-300 rounded-full">
                          {stage.challenges.length} چلنج
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleAddChallengeClick(stage)}
                            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition"
                          >
                            افزودن چلنج
                          </button>
                          <button
                            onClick={() => handleEditClick(stage)}
                            className="px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-lg transition"
                          >
                            ویرایش
                          </button>
                          <button
                            onClick={() => handleDeleteClick(stage)}
                            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition"
                          >
                            حذف
                          </button>
                          {stage.challenges.length > 0 && (
                            <button
                              onClick={() => toggleStageExpand(stage.id)}
                              className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded-lg transition"
                            >
                              {expandedStages[stage.id]
                                ? "بستن"
                                : "مشاهده چلنج‌ها"}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>

                    {/* ردیف باز شده برای چلنج‌ها */}
                    {expandedStages[stage.id] &&
                      stage.challenges.length > 0 && (
                        <tr>
                          <td colSpan="4" className="px-6 py-4 bg-gray-900">
                            <div className="space-y-3">
                              <h5 className="text-white font-medium mb-3 flex items-center gap-2">
                                <span className="w-1 h-5 bg-blue-500 rounded"></span>
                                چلنج‌های استیج: {stage.name}
                              </h5>
                              <div className="overflow-x-auto">
                                <table className="w-full">
                                  <thead className="bg-gray-800">
                                    <tr>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        ID
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        نام چلنج
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        مدت (روز)
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        تاریخ شروع
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        تاریخ پایان
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        وضعیت
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        ترتیب
                                      </th>
                                      <th className="px-4 py-2 text-right text-xs font-medium text-gray-400">
                                        عملیات
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="divide-y divide-gray-700">
                                    {stage.challenges.map((challenge) => (
                                      <tr
                                        key={challenge.id}
                                        className="hover:bg-gray-800 transition"
                                      >
                                        <td className="px-4 py-3 text-sm text-white">
                                          {challenge.id}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-white font-medium">
                                          {challenge.name}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-300">
                                          {challenge.duration}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-300">
                                          {new Date(
                                            challenge.start_at
                                          ).toLocaleString("fa-IR")}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-300">
                                          {new Date(
                                            challenge.end_at
                                          ).toLocaleString("fa-IR")}
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                          <span
                                            className={`font-medium ${getStatusColor(
                                              challenge.status
                                            )}`}
                                          >
                                            {getStatusText(challenge.status)}
                                          </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-300">
                                          {challenge.order}
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                          <div className="flex gap-2 flex-wrap">
                                            {/* 👇 دکمه فعال‌سازی */}
                                            <button
                                              onClick={() =>
                                                handleActivateChallenge(
                                                  challenge
                                                )
                                              }
                                              disabled={
                                                activatingChallenge ===
                                                challenge.id
                                              }
                                              className="px-3 py-1 bg-purple-600 hover:bg-purple-700 disabled:bg-purple-400 text-white text-xs rounded transition flex items-center gap-1"
                                            >
                                              {activatingChallenge ===
                                              challenge.id ? (
                                                <>
                                                  <div className="animate-spin rounded-full h-3 w-3 border-2 border-white border-t-transparent"></div>
                                                  در حال فعال‌سازی...
                                                </>
                                              ) : (
                                                <>⚡ فعال‌سازی</>
                                              )}
                                            </button>

                                            <button
                                              onClick={() =>
                                                setEditingChallenge(challenge)
                                              }
                                              className="px-3 py-1 bg-yellow-600 hover:bg-yellow-700 text-white text-xs rounded transition"
                                            >
                                              ویرایش
                                            </button>
                                            <button
                                              onClick={() =>
                                                setDeletingChallenge(challenge)
                                              }
                                              className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-xs rounded transition"
                                            >
                                              حذف
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-8 text-center">
          <p className="text-gray-400">هیچ استیجی یافت نشد</p>
        </div>
      )}

      {/* مودال ویرایش استیج */}
      {editingStage && (
        <EditStageModal
          stage={editingStage}
          onClose={handleCloseModal}
          onSuccess={handleUpdateSuccess}
        />
      )}

      {/* مودال حذف استیج */}
      {deletingStage && (
        <DeleteConfirmModal
          stage={deletingStage}
          onClose={handleCloseDeleteModal}
          onSuccess={handleDeleteSuccess}
        />
      )}

      {/* مودال افزودن چلنج */}
      {addingChallengeToStage && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <CreateChallengeForm
              stageId={addingChallengeToStage.id}
              stageName={addingChallengeToStage.name}
              onSuccess={handleChallengeCreated}
              onCancel={handleCancelAddChallenge}
            />
          </div>
        </div>
      )}

      {/* مودال ویرایش چلنج */}
      {editingChallenge && (
        <EditChallengeModal
          challenge={editingChallenge}
          onClose={() => setEditingChallenge(null)}
          onSuccess={() => {
            setEditingChallenge(null);
            onRefresh();
          }}
        />
      )}

      {/* مودال حذف چلنج */}
      {deletingChallenge && (
        <DeleteChallengeModal
          challenge={deletingChallenge}
          onClose={() => setDeletingChallenge(null)}
          onSuccess={() => {
            setDeletingChallenge(null);
            onRefresh();
          }}
        />
      )}
    </div>
  );
};

export default StagesList;
